import { FormControl } from '@angular/forms';
import { Injectable } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { CountryAbbreviationEnum } from 'src/app/shared/enum/country-abbreviation.enum';
import { RegexEnum } from 'src/app/core/enum/regex.enum';


@Injectable({
  providedIn: 'root'
})
export class UpdateSupplierFormService {

  constructor(private formbuilder: FormBuilder) { }

  /**
   * Get Update Supplier Form
   * @param data
   * @returns FormGroup
   */
  public getUpdateSupplierForm(supplier): FormGroup {
    return this.formbuilder.group({
      name: [supplier.name, Validators.required],
      nameLocation: [supplier.locationName, Validators.required],
      address: [supplier.address, Validators.required],
      city: [supplier.city, Validators.required],
      state: [supplier.state, Validators.required],
      postalCode: [supplier.zipCode, Validators.required],
      countryCode: [supplier.country || CountryAbbreviationEnum.USA, Validators.required],
      emailContact: [supplier.emailContact, [Validators.required, Validators.pattern(RegexEnum.EMAIL)]],
      phoneContact: [supplier.phoneContact, Validators.required],
      nameContact: [supplier.nameContact, Validators.required]
    });
  }
}
